/* eslint-disable react-hooks/rules-of-hooks */

import { useGetExternalRedirectUri } from 'core/api/client/MemberExperienceApi';
import { usePostMock } from 'core/api/mocks';
import { smartMockApi } from 'core/api';

import GetExternalRedirectUrlPayload from './mocks/GetExternalRedirectUrlPayload.mock.json';

export default smartMockApi({
	useTAL34GetExternalRedirectUrl: {
		live: useGetExternalRedirectUri,
		mock: () => {
			return usePostMock({ payload: GetExternalRedirectUrlPayload });
		},
	},
});
